import { currencyFormatConfig, defaultCurrencyFormatConfig, CURRENCY_CODE_PLACEHOLDER, VALUE_PLACEHOLDER, } from './currency-format-config';
export var isWholeNumber = function (value) { return Math.floor(value) === value; };
export var getCurrencyFormatConfig = function (currencyCode) {
    return currencyFormatConfig[currencyCode] || defaultCurrencyFormatConfig;
};
export var getFormattedPriceValue = function (value, currencyCode) {
    var config = getCurrencyFormatConfig(currencyCode);
    return value.toFixed(!isWholeNumber(value) ? config.decimalDigits : 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
export var getFormattedPrice = function (value, currencyCode) {
    var config = getCurrencyFormatConfig(currencyCode);
    return config.format
        .replace(VALUE_PLACEHOLDER, getFormattedPriceValue(value, currencyCode))
        .replace(CURRENCY_CODE_PLACEHOLDER, currencyCode);
};
export var getFormattedMoney = function (money) { var _a; return getFormattedPrice(Number((_a = money.amount) !== null && _a !== void 0 ? _a : 0), money.currency); };
//# sourceMappingURL=formatter.js.map